export default __webpack_public_path__ + "static/media/completed.0732a5c3.jpg";